export default [
  {
    path: '/relVendasProdutos/',
    name: 'relVendasProdutos',
    title: 'relVendasProdutos',
    component: () => import('../views/RelVendasProdutosView.vue'),
    redirect: { name: 'relVendasProdutos-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relVendasProdutos-listar',
        component: () => import('../views/RelVendasProdutosWelcomeView.vue'),
        meta: {
          title: 'Relatório vendas de produtos',
        },
      },
    ],
  },
];
